import { Box, CardMedia, Icon, Typography } from '@mui/material'
import React from 'react'
import defaultImage from 'assets/images/default_avatar.png'

const RevieweesCard = ({revieweeDetails}) => {
    
    return (
        <Box
            height="calc(100vh - 75px)"
            bgcolor="white.main"
            boxShadow="0px 0px 10px lightgray"
            position="sticky"
            top={75}
        >
            <Box
                width="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                p={3}
                borderBottom="1px solid"
                borderBottomColor="gray-line.main"
            >
                <CardMedia
                    component="img"
                    sx={{
                        height: 150,
                        width: 150,
                        objectFit: 'cover',
                        borderRadius: '50%',
                        mb: 2
                    }}
                    src={revieweeDetails?.reviewee_image ? revieweeDetails?.reviewee_image : defaultImage}
                />
                <Typography>{revieweeDetails?.reviewee_name}</Typography>
                <Typography color="light-gray-text.main">{revieweeDetails?.reviewee_department_name}</Typography>
            </Box>

            {/* Feedback section */}
            {revieweeDetails?.has_feedback === 1 && revieweeDetails?.feedback === null ? (
                <Box px={5} py={3}>
                    <Typography color="light-gray-text.main" mb={3}>Reviewee feedback</Typography>
                    <Box
                        width="100%"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        gap={2}
                    >
                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            width={70}
                            height={70}
                            borderRadius="50%"
                            backgroundColor="gray-background.main"
                        >
                            <Icon
                                sx={{
                                    color: "light-gray-text-2.main",
                                    fontSize: 30
                                }}
                            >
                                chat
                            </Icon>
                        </Box>
                        <Typography variant="h4" textAlign="center" color="light-gray-text.main">No feedback yet. Any feedback from your reviewee will show up here</Typography>
                    </Box>
                </Box>
            ) : revieweeDetails?.has_feedback === 1 && revieweeDetails?.feedback !== null ? (
                <Box px={5} py={3}>
                    <Typography variant="body1" color="light-gray-text.main" mb={3}>Reviewee Feedback</Typography>
                    <Typography variant="h4">{revieweeDetails?.feedback}</Typography>
                </Box>
            ) : null}
        </Box>
    )
}

export default RevieweesCard